<h1 mat-dialog-title>{{ this.data.title | translate }}</h1>
<form name="f" (ngSubmit)="f.form.valid && submit()" #f="ngForm" novalidate>
  <mat-dialog-content>
    <!-- Row 0 -->
    <div class="container" fxLayout="row" fxLayoutGap="30px">
      <!-- Tipo -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <mat-label>{{ 'User.Type' | translate }}</mat-label>
          <select matNativeControl [(ngModel)]="user.type" name="type" required>
            <option value="final" selected>{{ 'User.Final' | translate }}</option>
            <option value="tech">{{ 'User.Technician' | translate }}</option>
          </select>
        </mat-form-field>
      </div>
      <!-- Idioma -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <mat-label>{{ 'AppComponent.Language' | translate }}</mat-label>
          <select matNativeControl [(ngModel)]="this.user.selectedLang" name="selectedLang" required>
            <option value="pt">{{ 'AppComponent.LanguagePortuguese' | translate }}</option>
            <option value="en">{{ 'AppComponent.LanguageEnglish' | translate }}</option>
            <option value="es">{{ 'AppComponent.LanguageSpanish' | translate }}</option>
          </select>
        </mat-form-field>
      </div>
      <!-- Empresa - Solo para usuarios multiempresa -->
      <div class="field-container" *ngIf="this.authService.hasMultipleCompanies()" fxFlex>
        <mat-form-field>
          <mat-label>{{ 'AppComponent.Company' | translate }}</mat-label>
          <select
            name="selectedCompany"
            [(ngModel)]="user.company"
            (ngModelChange)="loadCompanyVoiceConfig()"
            matNativeControl
            required
            [disabled]="this.data.operation === 'update'"
          >
            <option [ngValue]="undefined" selected>{{ 'Partition.SelectCompany' | translate }}</option>
            <option *ngFor="let c of filteredCompanies" [ngValue]="c._id">{{ c.name }}</option>
          </select>
        </mat-form-field>
      </div>
    </div>
    <!-- Row 1 -->
    <div class="container" fxLayout="row" fxLayoutGap="30px">
      <!-- Usuario -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <input
            matInput
            name="email"
            type="email"
            customEmail
            [(ngModel)]="user.email"
            (ngModelChange)="emailErrorMatcher.setUserExists(false)"
            #email="ngModel"
            placeholder="{{ 'User.Email' | translate }}"
            matInput
            email
            required
            autocomplete="false"
            [errorStateMatcher]="emailErrorMatcher"
          />
          <button
            type="button"
            *ngIf="user.email"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="user.email = ''"
            tabindex="-1"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="email.invalid && email.errors?.required">{{ 'User.RequiredField' | translate }}</mat-error>
          <mat-error *ngIf="user.email && email.invalid && email.errors?.customEmail">{{
            'User.InvalidFormat' | translate
          }}</mat-error>
          <mat-error *ngIf="emailErrorMatcher.getUserExists()">{{ 'User.EmailUsed' | translate }}</mat-error>
        </mat-form-field>
      </div>
      <!-- Contraseña -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <button
            type="button"
            matPrefix
            [disabled]="generatingPassword"
            type="button"
            mat-button
            (click)="generatePassword()"
            class="genPassButton"
            color="accent"
          >
            {{
              (generatingPassword ? 'User.Generating' : data.operation === 'add' ? 'User.Generate' : 'User.Regenerate')
                | translate
            }}
          </button>
          <input
            matInput
            name="password"
            [ngModel]="user.pass"
            #password="ngModel"
            matInput
            readonly
            autocomplete="false"
            class="generatedPassInput"
            [required]="data.operation === 'add' && !generatingPassword"
          />
          <mat-spinner
            matSuffix
            *ngIf="generatingPassword"
            class="generatedPassInput"
            [diameter]="20"
            color="accent"
          ></mat-spinner>
          <mat-hint> {{ 'User.PassSend' | translate }}</mat-hint>
          <mat-error *ngIf="password.invalid && password.errors?.required">{{
            'User.RequiredField' | translate
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <!-- Row 2 -->
    <div class="container" fxLayout="row" fxLayoutGap="30px">
      <!-- Nombre -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <input
            matInput
            name="name"
            [(ngModel)]="user.name"
            #name="ngModel"
            placeholder="{{ 'User.Name' | translate }}"
            minlength="2"
            maxlength="20"
            matInput
            required
            autocomplete="false"
          />
          <button
            type="button"
            *ngIf="user.name"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="user.name = ''"
            tabindex="-1"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="name.invalid && name.errors.required">{{ 'User.RequiredField' | translate }}</mat-error>
          <mat-error *ngIf="name.invalid && name.errors.minlength">{{ 'User.MinField' | translate }}</mat-error>
          <mat-error *ngIf="name.invalid && name.errors.maxlength">{{ 'User.MaxField' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <!-- Apellido -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <input
            matInput
            name="lastName"
            [(ngModel)]="user.lastName"
            #lastName="ngModel"
            placeholder="{{ 'User.Surname' | translate }}"
            minlength="2"
            maxlength="20"
            matInput
            required
            autocomplete="false"
          />
          <button
            type="button"
            *ngIf="user.lastName"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="user.lastName = ''"
            tabindex="-1"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="lastName.invalid && lastName.errors.required">{{
            'User.RequiredField' | translate
          }}</mat-error>
          <mat-error *ngIf="lastName.invalid && lastName.errors.minlength">{{ 'User.MinField' | translate }}</mat-error>
          <mat-error *ngIf="lastName.invalid && lastName.errors.maxlength">{{ 'User.MaxField' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="container phone-container" style="color: #091e42">
      <mat-label>{{ 'User.WhatsappNumber' | translate }}</mat-label>
      <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
        <mat-form-field appearance="outline" style="width: 135.25px; height: 58px" required>
          <div style="position: absolute; top: 10px; left: 10px">
            <div style="display: flex; gap: 10px; align-items: flex-end">
              <img
                *ngIf="selectedCountry?.phone == null"
                style="width: 20px; height: 20px; position: absolute; top: 0px; left: 25px"
                src="assets/img/flags/globe.svg"
                alt="globe"
              />
              <img
                *ngIf="selectedCountry?.phone != null"
                style="width: 20px; height: 20px"
                [src]="'assets/img/flags/' + selectedCountry.code.toLowerCase() + '.svg'"
                alt="{{ selectedCountry?.name }}"
                matTooltip="{{ selectedCountry?.name }}"
              />
              <span *ngIf="selectedCountry?.phone != null">{{ selectedCountry?.phone }}</span>
            </div>
          </div>
          <div class="option-text">
            <mat-select
              name="country"
              #selectedCountryRef
              [(ngModel)]="selectedCountry"
              [errorStateMatcher]="countrySelectorErrorMatcher"
              (selectionChange)="onChangeCountry($event.value)"
            >
              <mat-option
                [value]="country"
                matTooltip="{{ country.name }}"
                *ngFor="let country of countriesFlagsPhones"
              >
                <img
                  *ngIf="country.code"
                  [src]="'assets/img/flags/' + country.code.toLowerCase() + '.svg'"
                  style="width: 20px; height: 20px; position: absolute; top: 15px; left: 49px"
                />
              </mat-option>
            </mat-select>
          </div>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 258px; height: 58px">
          <input
            matInput
            type="text"
            name="phone"
            maxLength="16"
            #phone="ngModel"
            autocomplete="off"
            id="whatsappNumber"
            [(ngModel)]="whatsappNumber"
            (input)="onPhoneChange($event)"
            matTooltip="{{ 'User.WhatsappNumber' | translate }}"
            placeholder="{{ 'User.WhatsappNumberPlaceholder' | translate }}"
            [errorStateMatcher]="this.whatsappNumber !== undefined && phoneErrorMatcher"
          />
        </mat-form-field>
      </div>
      <mat-error
        class="error"
        style="font-size: 12px; padding-top: 10px; margin-bottom: 10px"
        *ngIf="isPhoneInvalidCheck()"
      >
        <ul>
          <li *ngIf="this.whatsappNumber !== undefined && isRequiredCountry()">
            {{ 'Profile.InvalidCountryCode' | translate }}
          </li>
          <li *ngIf="this.whatsappNumber !== undefined && isPhoneInvalidCheck()">
            {{ 'User.InvalidNumberForThisMask' | translate }}
          </li>
        </ul>
      </mat-error>
    </div>

    <!-- Row 3 -->
    <div class="container" fxLayout="row" fxLayoutGap="30px">
      <!-- Tiempo de acceso seguro -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <input
            matInput
            type="number"
            name="secureAccessTime"
            [(ngModel)]="user.secureAccessTime"
            #secureAccessTime="ngModel"
            placeholder="{{ 'User.SecureAccess' | translate }}"
            (ngModelChange)="validateSecureAccessTime()"
            [errorStateMatcher]="secureAccessTimeErrorMatcher"
            matInput
            required
            autocomplete="false"
          />
          <button
            type="button"
            *ngIf="user.secureAccessTime"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="user.secureAccessTime = defaultSAT"
            tabindex="-1"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint> {{ 'User.Time' | translate }} </mat-hint>
          <mat-error *ngIf="user.secureAccessTime === undefined">{{ 'User.RequiredField' | translate }}</mat-error>
          <mat-error
            *ngIf="user.secureAccessTime && (user.secureAccessTime > maxSAT || user.secureAccessTime < minSAT)"
            >{{ 'User.InvalidValue' | translate }}</mat-error
          >
        </mat-form-field>
      </div>

      <!-- Tiempo de aviso de acceso seguro -->
      <div class="field-container" fxFlex>
        <mat-form-field>
          <input
            matInput
            type="number"
            name="secureAccessWarning"
            [(ngModel)]="user.secureAccessWarning"
            #secureAccessWarning="ngModel"
            placeholder="{{ 'User.SecureAccessWarn' | translate }}"
            (ngModelChange)="validateSecureAccessWarning()"
            [errorStateMatcher]="secureAccessWarningErrorMatcher"
            matInput
            autocomplete="false"
          />
          <button
            type="button"
            *ngIf="user.secureAccessWarning"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="user.secureAccessWarning = undefined"
            tabindex="-1"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint> {{ 'User.Time' | translate }} </mat-hint>
          <mat-error
            *ngIf="user.secureAccessWarning && (user.secureAccessWarning > maxSAT || user.secureAccessWarning < minSAT)"
            >{{ 'User.InvalidValue' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <!-- Row 4 - Safe Word -->
    <div *ngIf="isKaironVoiceEnabled" class="container" fxLayout="column" fxLayoutGap="15px">
      <!-- Banner de aviso se houver alteração pendente -->
      <div *ngIf="user.hasPendingSafeWord" class="pending-warning-banner" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon>hourglass_empty</mat-icon>
        <span>{{ 'User.PendingSafeWordWarning' | translate }}</span>
      </div>

      <div fxLayout="row" fxLayoutGap="30px">
        <div class="field-container" fxFlex>
          <mat-form-field>
            <input
              matInput
              type="password"
              name="safeWord"
              [(ngModel)]="user.safeWord"
              #safeWord="ngModel"
              placeholder="{{ 'User.SafeWord' | translate }}"
              maxlength="20"
              pattern="^[a-zA-Z0-9]*$|^••••••••$"
              autocomplete="off"
            />
            <button
              type="button"
              *ngIf="user.safeWord"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="user.safeWord = ''"
              tabindex="-1"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="safeWord.invalid && safeWord.errors?.pattern">
              {{ 'User.SafeWordAlphanumericError' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="field-container" fxFlex></div>
      </div>
    </div>

    <!-- Row 5 -->
    <div *ngIf="data.operation !== 'add'" class="container" fxLayout="row" fxLayoutGap="30px">
      <!-- Blanqueo de pines -->
      <div class="field-container" fxFlex>
        <mat-label *ngIf="user.forceChangeDisarmPass">{{ 'User.ResetDisarmPass' | translate }}</mat-label>
        <button
          *ngIf="!user.forceChangeDisarmPass"
          type="button"
          color="primary"
          mat-raised-button
          (click)="resetingDisarmPass()"
          style="width: 50%"
        >
          {{ (resetDisarmPass ? 'User.CancelResetPass' : 'User.ResetDisPass') | translate }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [disabled]="!isValidData()">
      {{ this.data.submitText | translate }}
    </button>
    <button type="button" mat-raised-button (click)="onCancelClick()">{{ 'Shared.Cancel' | translate }}</button>
  </mat-dialog-actions>
</form>
